<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>


    <section class="content">
      <div class="container-fluid">
        <b-row class="col-lg-12">
          <div class="col-lg-4 col-md-4 col-sm-12"
            v-for="({ id, type, label, options, loaded, internalSearch, searchChange }) in filterInputs"
            v-bind:key="id">
            <b-form-group label-cols-lg="2" :label-for="id + '-filter-input'" :label="label" v-if="type === 'input'">
              <b-form-input :id="id + '-filter-input'" v-model="filters[id]" autocomplete="off"
                :state="validateState(id)" :placeholder="'Enter ' + label" />
            </b-form-group>
            <b-form-group label-cols-lg="2" :label-for="id + '-filter-input'" :label="label" v-if="type === 'select'">
              <multiselect v-model="filters[id]" :disabled="!loaded" :loading="!loaded" :options="options" label="name"
                track-by="id" :multiple="false" :placeholder="'Select ' + label" :internal-search="internalSearch"
                @search-change="searchChange" />
            </b-form-group>
          </div>
        </b-row>
        <b-row class="col-lg-12">
          <div class="col-lg-12 col-md-12 col-sm-12 apply-clear">
            <FilterButtons :cancel="this.cancel" :loadFn="loadItems" :cancelFn="cancelRequest"
              :resetFn="clearFilters" />
          </div>
        </b-row>
        <div class="row col-lg-12">
          <div class="form-group col-sm-2">
            <EditForm :default-values="{}" title="Create partner settings" @finish="handleItemsUpdate" create>
              <template #button="{ onclick }">
                <b-button type="button" variant="success" @click="onclick"><i class="fas fa-plus"></i> Create</b-button>
              </template>
            </EditForm>
          </div>
        </div>

        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="table-wrapper mb-10">
                <b-table :striped="true" :small="true" :hover="true" :empty-text="emptyText" show-empty :busy="!!cancel"
                  :items="filteredItems" :fields="fields">
                  <template #cell(actions)="row">
                    <EditForm :default-values="{ ...row.item }" title="Edit partner settings"
                      @finish="handleItemsUpdate" />
                    <RemoveForm :object="row.item.partnerId" message="Please confirm removing partner settings"
                      :url="'/api/v1/partners-settings/' + row.item.id" @finish="handleItemsUpdate"></RemoveForm>
                  </template>
                </b-table>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
import EditPartnerSettingsForm from "../../components/PartnerSettings/EditPartnerSettingsForm.vue";
import axios from "axios";
import { getRouteIcon, ROUTE_PROVIDER_NAMES } from "../../utils/routerIcons";
import FilterButtons from "../../components/FilterButtons.vue";
import Multiselect from "vue-multiselect";
import RemoveForm from "../../components/remove-form/RemoveForm.vue";

const getDefaultFilters = () => {
  return {
    id: null,
    name: null,
    table: null,
    gameType: null,
  };
}
export default {
  components: {
    RemoveForm,
    EditForm: EditPartnerSettingsForm,
    FilterButtons,
    Multiselect
  },
  data() {
    return {
      gameTypeOption: [],
      showEmpty: false,
      showError: false,
      cancel: null,
      error: null,
      fields: [
        { key: 'id', label: '_ID' },
        { key: 'partnerId', label: 'Operator ID' },
        { key: 'gameTypeDisplay', label: 'Game Type' },
        { key: 'actions', label: 'Actions' }
      ],
      items: [],
      filters: getDefaultFilters(),
    }
  },
  computed: {
    filterInputs() {
      return [
        {
          id: 'gameType',
          type: 'select',
          label: 'Game',
          placeholder: 'Game Type',
          options: this.gameTypeOption,
          internalSearch: false,
          loaded: this.$store.getters['gameTypes/loaded'],
          searchChange: () => {
          }
        },
        { id: 'partnerId', type: 'input', label: 'Operator ID', placeholder: 'Operator ID' },
        { id: 'id', type: 'input', label: 'ID', placeholder: 'ID' },
      ];
    },
    emptyText() {
      if (this.cancel) {
        return 'Loading items...';
      }

      if (this.error) {
        return this.error;
      }

      return 'There are no records to show';
    },
    routeIcon: () => getRouteIcon(ROUTE_PROVIDER_NAMES),
    filteredItems() {
      return this.items.map((item) => {
        return {
          ...item,
          gameTypeDisplay: this.gameTypeOption.find(({ id }) => id === item.gameType)?.name ?? item.gameType
        }
      });
    },
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    clearFilters() {
      this.filters = getDefaultFilters();
      this.loadItems();

    },
    handleItemsUpdate() {
      this.loadItems();
    },
    loadItems() {
      let loadingInstance = this.$veLoading({
        target: document.querySelector("#loading-container"),
        name: "wave",
      });

      this.items = [];

      let self = this;
      loadingInstance.show();

      this
        .$http({
          url: '/api/v1/partners-settings',
          method: 'GET',
          params: { ...this.filters, gameType: this.filters.gameType ? this.filters.gameType.id : null },
          cancelToken: new axios.CancelToken(c => {
            self.cancel = c
          })
        })
        .then(resp => {
          this.items = resp.data;
        })
        .catch((err) => {
          this.items = [];
          this.error = err;
        })
        .finally(() => {
          loadingInstance.close();
          this.cancel = null;
        });

    },
    cancelRequest() {
      if (this.cancel) {
        this.cancel('this -> cancel previous request');
      }
    },
    onFinishEdit() {
      this.loadItems();
    },
  },
  async beforeMount() {
    await this.$store.dispatch('gameTypes/loadList').then(() => {
      this.gameTypeOption = this.$store.getters['gameTypes/list'].map(({ name, id }) => {
        return { name, id }
      });
    });
  },
  mounted() {
    this.loadItems();
  }
}
</script>
